<template>
  <div>
    <b-table
      v-if="logs.length"
      :items="logs"
      :fields="tableColumns"
      responsive
      bordered
    >
    </b-table>
    <b-alert
      v-else
      show
      variant="warning"
      class="p-1 mb-0"
    >
      Sin información
    </b-alert>
  </div>
</template>

<script>
export default {
  props: {
    logs: {
      type: Array,
      default: () => []
    }
  },
  setup () {
    //DATA
    const tableColumns = [
      { key: 'action', label: 'Acción'},
      { key: 'user.user', label: 'Usuario' },
      { key: 'created_at', label: 'Fecha'}
    ];

    return {
      tableColumns
    }
  }
}
</script>
